import axios from "axios";
import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { Link } from "react-router-dom";

export const Categories = () => {
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    getData();
  }, []);

  const getData = () => {
    axios
      .get("/category/public/shows")
      .then((res) => {
        const categoryData = res.data.data?.categories;
        setCategories(categoryData);
      })
      .catch((err) => console.log(err));
  };

  return (
    <div className="container-fluid pt-5">
      <h2 className="section-title position-relative text-uppercase mx-xl-5 mb-4 text-2xl font-bold">
        <span className="bg-secondary pr-3">DANH MỤC</span>
      </h2>
      <div className="row px-xl-5 pb-3">
        {categories.map((category, index) => (
          <div key={index} className="col-lg-3 col-md-4 col-sm-6 pb-1">
            <Link
              to={`/san-pham?c=${category.id}`}
              className="text-decoration-none"
            >
              <div className="cat-item img-zoom d-flex align-items-center mb-4">
                <div
                  className="overflow-hidden"
                  style={{ width: "100px", height: "100px" }}
                >
                  <img
                    className="img-fluid"
                    src={category.thumbnail}
                    alt={category.name}
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  />
                </div>
                <div className="flex-fill pl-3">
                  <h6>{category.name}</h6>
                  <small className="text-body">
                    {category.productCount} Sản phẩm
                  </small>
                </div>
              </div>
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
};
